module.exports = __webpack_public_path__ + "assets/img/1211587028359_.pic_hd.f6bf7ad7.jpg";